import Vue from 'vue'
import Router from 'vue-router'

// import Home from 'components/Home.vue'
import indexSla from 'components/sla/IndexSla.vue'
import ControleApuracaoSla from 'components/sla/ControleApuracaoSla.vue'
import Logout from 'components/loginLogout/Logout.vue'
import perfilUsuario from 'components/perfilUsuario/Perfil'
import InserirEvidencia from 'components/modal/InserirEvidencia'
import InserirNotificacao from '../components/notificacao/InserirNotificacao'
import ListarNotificacoes from '../components/notificacao/ListarNotificacoes'
import ExibirNotificacao from '../components/notificacao/ExibirNotificacao'
import ListarFechamentoExtra from 'components/aplicacaoFechamentoExtra/ListarFechamentoExtra'
import AplicarGlosaFranquias from 'components/aplicacaoGlosaFranquias/AplicarGlosaFranquias'
import ExibirFechamentoExtra from 'components/aplicacaoFechamentoExtra/ExibirFechamentoExtra'
import FormNotificacaoSemLogin from '../components/notificacao/form/FormExibirNotificacaoSemLogin.vue'
import LoginTokenTemporario from '../components/loginLogout/LoginTokenTemporario.vue'
import DownloadCsv from 'components/planilha/DownloadCsv'
import DetalhesFechamentoExtra from '../components/aplicacaoFechamentoExtra/DetalhesFechamentoExtra.vue'
import ExportarFechamentoExtra from '../components/planilha/extracontratual/ExportarFechamentoExtra.vue'
import ExportSla from 'components/planilha/planilhaGeral/ExportSla.vue'
import redirecionarUsuarioPorGrupo from 'components/loginLogout/redirecionar/Index.vue'
import RedirecionarAdministrativo from 'components/loginLogout/redirecionar/RedirecionarAdministrativo.vue'
import SimulacaoGeral from 'components/simulacaoPreventivas/SimulacaoGeral.vue'
import ImportarPreventivas from 'components/simulacaoPreventivas/ImportarPreventivas.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/autenticar/:hash',
      name: 'LoginTokenTemporario',
      component: LoginTokenTemporario
    },
    {
      path: '/redirecionarAdministrativo/',
      name: 'RedirecionarAdministrativo',
      component: RedirecionarAdministrativo
    },
    {
      path: '/simulacao-geral',
      name: 'SimulacaoGeral',
      component: SimulacaoGeral
    },
    {
      path: '/importar-preventivas',
      name: 'ImportarPreventivas',
      component: ImportarPreventivas
    },
    {
      path: '/FormNotificacaoEmail/:hash',
      name: 'FormNotificacaoEmail',
      component: FormNotificacaoSemLogin
    },
    {
      path: '/Logout/',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/listarSla',
      name: 'ListarSla',
      component: indexSla
    },
    {
      path: '/getslas',
      name: 'getSlas',
      component: ControleApuracaoSla
    },
    {
      path: '/perfilusuario',
      name: 'perfilusuario',
      component: perfilUsuario
    },
    {
      path: '/InserirEvidencia',
      name: 'InserirEvidencia',
      component: InserirEvidencia
    },
    {
      path: '/InserirNotificacao',
      name: 'InserirNotificacao',
      component: InserirNotificacao
    },
    {
      path: '/ListarNotificacoes',
      name: 'ListarNotificacoes',
      component: ListarNotificacoes
    },
    {
      path: '/ExibirNotificacao',
      name: 'ExibirNotificacao',
      component: ExibirNotificacao
    },
    {
      path: '/planilhas',
      name: 'Planilhas',
      component: DownloadCsv
    },
    {
      path: '/ListarFechamentoExtra',
      name: 'ListarFechamentoExtra',
      component: ListarFechamentoExtra
    },
    {
      path: '/AplicarGlosaFranquias',
      name: 'AplicarGlosaFranquias',
      component: AplicarGlosaFranquias
    },
    {
      path: '/ExibirFechamentoExtra',
      name: 'ExibirFechamentoExtra',
      component: ExibirFechamentoExtra
    },
    {
      path: '/DetalhesFechamentoExtra',
      name: 'DetalhesFechamentoExtra',
      component: DetalhesFechamentoExtra
    },
    {
      path: '/ExportarFechamentoExtra',
      name: 'ExportarFechamentoExtra',
      component: ExportarFechamentoExtra
    },
    {
      path: '/ExportSla',
      name: 'ExportSla',
      component: ExportSla
    },
    {
      path: '/redirecionar',
      name: 'redirecionarUsuarioPorGrupo',
      component: redirecionarUsuarioPorGrupo
    }
  ],
  linkActiveClass: 'active'
})



// WEBPACK FOOTER //
// ./src/router/index.js